module.exports = __webpack_public_path__ + "static/media/happy.1de5fb6b.png";